import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../http.service';
import { HttpRequestHandler } from '../../models/http-model';
const HEADERS = {};

@Injectable()
export class LegalEntityService {

    static ENV = environment;
    constructor(private httpService: HttpService) {
    }

    public consultLegalEntity(data: any, httpRequesthandler: HttpRequestHandler): void {
        httpRequesthandler.headers = HEADERS;
        this.httpService.post(LegalEntityService.ENV.environment.API.consult_legal_entity, data, httpRequesthandler);
    }

    public editLegalEntity(data: any, httpRequesthandler: HttpRequestHandler): void {
        httpRequesthandler.headers = HEADERS;
        this.httpService.post(LegalEntityService.ENV.environment.API.edit_legal_entity, data, httpRequesthandler);
    }

    public consultState(data: any, httpRequesthandler: HttpRequestHandler): void {
        httpRequesthandler.headers = HEADERS;
        this.httpService.post(LegalEntityService.ENV.environment.API.consult_state, data, httpRequesthandler);
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/legal-entity/legal-entity.service.ts